import React from 'react';
import { Outlet } from 'react-router-dom';

const EspaceMessagesLayout: React.FC = () => {
  return <Outlet />;
};

export default EspaceMessagesLayout;
